import { GetServerSideProps } from 'next'
import { KK_LANG_IDS, Locale } from '@model/locales'
import { getSupportContents, StaticContentType } from '@api/content'

export { SupportPage as default } from '@components/pages/SupportPage'

export const getServerSideProps: GetServerSideProps = async ({ query, req, locale }) => {
  const languageId = KK_LANG_IDS[locale as Locale]

  const types: { [key: string]: StaticContentType } = {
    frequently_asked_questions: 'FAQ',
    terms_and_conditions: 'TERMS_AND_CONDITIONS',
    returns: 'PRODUCT_RETURNS',
    size_charts: 'SIZE_CHARTS',
  }

  const data = await getSupportContents(languageId, types[query.tab as string])
  if (data) {
    return {
      props: { content: data, tab: query.tab },
    }
  }
  return {
    props: { content: [], tab: query.tab },
  }
}
